var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isMobile)?_c('ComponentHeaderWithLink',[_vm._v(_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_c(_vm.getCategoriesType,{tag:"component",attrs:{"categories":_vm.items}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }